if (process.env.NODE_ENV === "production") {
  const { withScope, captureException } = require("@sentry/react")
  module.exports.log = function log(error: unknown) {
    withScope(() => {
      captureException(error)
    })
    console.log(error)
  }
} else {
  module.exports.log = function log(error: unknown) {
    console.log(error)
  }
}
